import { manufacturingFetch } from "@/lib/manufacturingClient";

export type OutlookBoardRow = {
  id: string;
  serial: string;
  phase_key: string | null;
  phase_name: string;
  build_on: string | null;
  horizon_days: 7 | 14 | 30;
};

export function listOutlookBoard(query: string) {
  const q = query.trim();
  const path = q ? `/api/mfg/inventory-outlook/board?q=${encodeURIComponent(q)}` : "/api/mfg/inventory-outlook/board";
  return manufacturingFetch<{ ok: true; units: OutlookBoardRow[] }>(path, { method: "GET" });
}

export function placeOutlookUnit(body: { op: "next" | "build_on" | "deliver"; unit_id: string; build_on?: string }) {
  return manufacturingFetch<{ ok: true; units: OutlookBoardRow[] }>("/api/mfg/inventory-outlook/board", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
